import type { Form } from 'types';

import { FormRowContextProvider } from './FormRowContext';
import { Row } from './Row';
import { AnchorCell } from './AnchorCell';
import { BadgesCell } from './BadgesCell';
import { CheckboxCell } from './CheckboxCell';
import { IdCell } from './IdCell';
import { UpdatedAtCell } from './UpdatedAtCell';

type Props = {
  form: Form;
};

export const FormsTableItemRow = ({ form }: Props) => {
  return (
    <FormRowContextProvider form={form}>
      <Row>
        <CheckboxCell />
        <AnchorCell />
        <IdCell />
        <UpdatedAtCell />
        <BadgesCell />
      </Row>
    </FormRowContextProvider>
  );
};
